import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../components/useAuth';
import axios from 'axios';
import { headerPublic } from '../components/header.encry';
import { persistAuthData } from '../utils/authStorage';
import { Eye, EyeOff, ArrowRight, LockKeyhole } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
function Login(props) {

    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const [isConnected, setIsConnected] = useState(false);
    const auth = useAuth();
    const { isAuthenticated } = auth;
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_PEGASUS_API_URL}/users/login`,
                {
                    username: login.trim(),
                    password: password,
                },
                headerPublic({ 'Content-Type': 'application/json' })
            );

            const data = response?.data || {};
            const jwtToken = data.token || data.token_jwt || data.access_token;
            if (!jwtToken) {
                throw new Error('Token manquant dans la réponse');
            }

            const user = data.user || {};
            const name = user.username || login;
            const roles = user.access_permissions || [];
            const affectedStoreIds = Array.isArray(user.affected_store_ids) ? user.affected_store_ids : [];
            const parentUser =
                typeof user.parentUser === 'object' && user.parentUser !== null
                    ? user.parentUser._id || user.parentUser.id || user.parentUser.$oid
                    : user.parentUser;

            sessionStorage.setItem('token', jwtToken);
            sessionStorage.setItem('name', name);
            sessionStorage.setItem('roles', JSON.stringify(roles));

            if (user.default_warehouse_id) {
                sessionStorage.setItem('warehouseId', user.default_warehouse_id);
            }
            if (user.default_storage_tag) {
                sessionStorage.setItem('dolitag', user.default_storage_tag);
            }
            if (user.default_store_id) {
                sessionStorage.setItem('default_store_id', user.default_store_id);
            }
            sessionStorage.setItem('affected_store_ids', JSON.stringify(affectedStoreIds));
            if (user._id) {
                sessionStorage.setItem('userId', user._id);
            }
            if (parentUser) {
                sessionStorage.setItem('parentUser', parentUser);
            }

            persistAuthData({
                token: jwtToken,
                name,
                roles,
                warehouseId: user.default_warehouse_id,
                dolitag: user.default_storage_tag,
                default_store_id: user.default_store_id,
                affected_store_ids: affectedStoreIds,
                userId: user._id,
                parentUser,
            });

            setIsConnected(true);
        } catch (error) {
            console.error('Login failed', error);
            const message = error?.response?.data?.response || error?.response?.data?.message || error.message;
            alert(message || 'Erreur de connexion');
        } finally {
            setSubmitting(false);
        }
    };


    useEffect(() => {
        if (isConnected || isAuthenticated) {
            try {
                const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
                const isAdminOrManager = Array.isArray(roles) && (roles.includes('admin') || roles.includes('manager'));
                if (Array.isArray(roles) && roles.includes('driver') && !isAdminOrManager) {
                    navigate('/driver/orders');
                } else {
                    navigate('/dashboard');
                }
            } catch (e) {
                navigate('/dashboard');
            }
        }
         document.body.classList.add('body-background');
  return () => {
    document.body.classList.remove('body-background');
  };
    }, [isConnected, isAuthenticated, navigate]);

    return (
        <main className="pegasus-ui pegasus-login">
            <section className="pegasus-login-story" aria-label="Le Céladon Pegasus">
                <div className="pegasus-login-wordmark">le céladon<span className="sc-text-muted-foreground">.</span></div>
                <div className="pegasus-login-editorial">
                    <div className="pegasus-login-eyebrow">Le quotidien, en harmonie</div>
                    <h1>Chaque détail.<br />Une <em>belle équipe.</em></h1>
                    <p>Des commandes bien organisées, des équipes engagées et des établissements qui avancent ensemble. Un seul espace pour simplifier le quotidien et construire la réussite collective.</p>
                </div>
                <div className="pegasus-login-story-footer">PEGASUS / LE CÉLADON</div>
            </section>
            <section className="pegasus-login-panel" aria-labelledby="pegasus-login-title">
                <div className="pegasus-login-card">
                    <img src="/adminKit/img/photos/logo.png" className="pegasus-login-logo" alt="Le Céladon" />
                    <h2 id="pegasus-login-title">Ravi de vous retrouver.</h2>
                    <p className="pegasus-login-subtitle">Connectez-vous à votre espace Pegasus.</p>
                    <form onSubmit={handleSubmit}>
                        <label className="pegasus-login-label" htmlFor="email">Identifiant</label>
                        <Input id="email" type="text" autoComplete="username" placeholder="Votre identifiant" value={login}
                            onChange={event => setLogin(event.target.value)} />
                        <label className="pegasus-login-label" htmlFor="pwd">Mot de passe</label>
                        <div className="pegasus-password-field">
                            <Input id="pwd" type={showPassword ? 'text' : 'password'} autoComplete="current-password"
                                placeholder="Votre mot de passe" value={password} onChange={event => setPassword(event.target.value)} />
                            <Button variant="ghost" size="icon" className="pegasus-password-toggle" aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                                aria-pressed={showPassword} onClick={() => setShowPassword(previous => !previous)}>
                                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                            </Button>
                        </div>
                        <div className="sc-flex sc-justify-end sc-mt-3 sc-mb-6">
                            <button type="button" className="pegasus-login-help" onClick={() => navigate('/screens/login')}>Mot de passe oublié ?</button>
                        </div>
                        <Button type="submit" className="sc-w-full" disabled={submitting}>
                            {submitting ? 'Connexion…' : 'Se connecter'}<ArrowRight size={16} />
                        </Button>
                    </form>
                    <div className="pegasus-login-note"><LockKeyhole size={13} />Votre espace de travail, en toute confiance.</div>
                </div>
            </section>
        </main>
    );
}

export default Login;
